import { useContext } from 'react';

import { HoneycombToolbarConfigContext } from '../context/honeycomb-toolbar-config.context.js';
export const useHoneycombToolbarConfig = () => {
  return useContext(HoneycombToolbarConfigContext);
};
